export default __webpack_public_path__ + "static/char-62-anr-e9311d92d7338242f6c9d826ce1a83ef.webp";